import { GET_LOADING_DATA } from "./constants";

export const setModalLoading = (flag) => async (dispatch) => {
  dispatch({
    type: GET_LOADING_DATA,
    payload: flag,
  });
};
